module.exports = __webpack_public_path__ + "static/media/castello-branco-advogados-associados-cartao-visita-768x591.8f034a2b.jpg";